/**
 * Created by spepa on 13.05.2024
 */

cleverapps.personDemo = function () {
    const params = cleverapps.getRequestParameters();
    if (params.personDemo === undefined || !cleverapps.config.debugMode) {
        return;
    }

    const startDialogue = function (role) {
        cleverapps.focusManager.displayWhenFreeFocus({
            focus: "LevelTutorial",
            action: function (f) {
                const steps = [
                    {
                        text: "Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.",
                        person: role,
                        person2: {
                            role,
                            orientation: "right"
                        }
                    },
                    {
                        text: "Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.",
                        person: {
                            role,
                            orientation: "right"
                        },
                        person2: role
                    }
                ];

                const dialogue = new Dialogue(steps, {
                    showUp: true,
                    autoClose: true,
                    autoScroll: false,
                    bundles: [params.personDemo]
                });

                dialogue.on("afterClose", f);
                new DialogueView(dialogue);
            }
        });
    };

    cleverapps.whenAllInitialized(() => {
        for (const role in cleverapps.persons.getData()) {
            if (cleverapps.persons.getRole(role).name === params.personDemo) {
                startDialogue(role);
            }
        }
    });
};
